import { FC } from 'react';
import styled from 'styled-components';

type SpaceComponentProps = {
  height?: number;
  width?: number;
};
/* eslint-disable @typescript-eslint/no-unused-vars */
const SpaceComponent: FC<SpaceComponentProps> = ({
  height,
  width,
  ...props
}) => {
  return <div {...props} />;
};
const Space = styled(SpaceComponent)`
  width: ${({ width }) => (width ? `${width}rem` : '0')};
  height: ${({ height }) => (height ? `${height}rem` : '0')};
`;

export default Space;
